/**
 * Web mock for @react-native-async-storage/async-storage
 * Uses localStorage for web platform
 */

// Simple localStorage-based implementation
const AsyncStorage = {
  getItem: async (key) => {
    try {
      const item = localStorage.getItem(key);
      return item;
    } catch (error) {
      console.error('AsyncStorage.getItem error:', error);
      return null;
    }
  },

  setItem: async (key, value) => {
    try {
      localStorage.setItem(key, value);
      return null;
    } catch (error) {
      console.error('AsyncStorage.setItem error:', error);
      throw error;
    }
  },

  removeItem: async (key) => {
    try {
      localStorage.removeItem(key);
      return null;
    } catch (error) {
      console.error('AsyncStorage.removeItem error:', error);
      throw error;
    }
  },

  clear: async () => {
    try {
      localStorage.clear();
      return null;
    } catch (error) {
      console.error('AsyncStorage.clear error:', error);
      throw error;
    }
  },

  getAllKeys: async () => {
    try {
      return Object.keys(localStorage);
    } catch (error) {
      console.error('AsyncStorage.getAllKeys error:', error);
      return [];
    }
  },

  multiGet: async (keys) => {
    try {
      return keys.map(key => [key, localStorage.getItem(key)]);
    } catch (error) {
      console.error('AsyncStorage.multiGet error:', error);
      return [];
    }
  },

  multiSet: async (keyValuePairs) => {
    try {
      keyValuePairs.forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
      return null;
    } catch (error) {
      console.error('AsyncStorage.multiSet error:', error);
      throw error;
    }
  },

  multiRemove: async (keys) => {
    try {
      keys.forEach(key => localStorage.removeItem(key));
      return null;
    } catch (error) {
      console.error('AsyncStorage.multiRemove error:', error);
      throw error;
    }
  },
};

// Hook implementation for useAsyncStorage
export const useAsyncStorage = (key) => {
  return {
    getItem: () => AsyncStorage.getItem(key),
    setItem: (value) => AsyncStorage.setItem(key, value),
    removeItem: () => AsyncStorage.removeItem(key),
  };
};

// Export default
export default AsyncStorage;

